export default [
  {
    title: 'Entry',
    list: [
      {
        title: '$1-₹50',
        min: 100,
        max: 5000,
        isSelected: false
      },
      {
        title: '$51-$100',
        min: 5100,
        max: 10000,
        isSelected: false
      },
      {
        title: '$101-$1,000',
        min: 10100,
        max: 100000,
        isSelected: false
      },
      {
        title: '$1,001 & above',
        min: 100100,
        max: 100000000000,
        isSelected: false
      }
    ]
  },
  {
    title: 'No Of Teams',
    list: [
      {
        title: '2',
        min: 2,
        max: 2,
        isSelected: false
      },
      {
        title: '3-10',
        min: 3,
        max: 10,
        isSelected: false
      },
      {
        title: '11-100',
        min: 11,
        max: 100,
        isSelected: false
      },
      {
        title: '101 & 1,000',
        min: 101,
        max: 1000,
        isSelected: false
      },
      {
        title: '1,001 & above',
        min: 1001,
        max: 1000000000,
        isSelected: false
      }
    ]
  },
  {
    title: 'Prize Pool',
    list: [
      {
        title: '$1-$10,000',
        min: 100,
        max: 1000000,
        isSelected: false
      },
      {
        title: '$10,001 & above',
        min: 1000100,
        max: 10000000000,
        isSelected: false
      }
    ]
  },
  {
    title: 'Contest Type',
    list: [
      {
        title: 'Single Entry',
        min: 1,
        max: 10000,
        isSelected: false
      },
      {
        title: 'Multi Entry',
        min: 100001,
        max: 100000000,
        isSelected: false
      },
      {
        title: 'Confirmed',
        min: 100001,
        max: 100000000,
        isSelected: false
      }
    ]
  }
];
